import { useAtom } from 'jotai';
import { useCallback } from 'react';

import { tourneyAtom } from '@/store';
import { initialDataTourneys, InitialDataTourneys } from '@/store/tourneys';

// Este hook es utilizado para poder guardar data provicional de la registracion
const useTourney = () => {
  const [tourneyData, setTourneyData] = useAtom(tourneyAtom);

  const handleSetTourney = (data: InitialDataTourneys) => {
    setTourneyData(data);
  };

  const updateTourney = useCallback(
    (updates: Partial<InitialDataTourneys>) => {
      setTourneyData((prev) => ({
        ...prev,
        ...updates,
      }));
    },
    [setTourneyData]
  );

  const handleResetTourney = useCallback(() => {
    setTourneyData(initialDataTourneys);
  }, [setTourneyData]);

  return {
    tourneyData,
    handleSetTourney,
    handleResetTourney,
    updateTourney,
  };
};

export default useTourney;
